module.exports = __webpack_public_path__ + "static/media/oop.0fd5adbe.png";